class CustomSlider extends HTMLElement {
  constructor() {
    super();
    const swiper = new Swiper(this.querySelector(".swiper"), {
      // Optional parameters
      direction: "horizontal",
      initialSlide: 1,
      loop: true,
      effect: "creative",
      perspective: true,
      limitProgress: 1,
      shadowPerProgress: true,
      progressMultiplier: 1,

      creativeEffect: {
        prev: {
          scale: 0.7,
          translate: ["-80%", 0, 0],
        },
        next: {
          scale: 0.7,
          translate: ["80%", 0, 0],
        },
      },
      749: {
        creativeEffect: {
          prev: {
            scale: 0.7,
            translate: ["-83%", 0, 0],
          },
          next: {
            scale: 0.7,
            translate: ["83%", 0, 0],
          },
        },
      },
    });
  }
}

customElements.define("custom-slider", CustomSlider);
